module.exports = __webpack_public_path__ + "img/una-branco.bb3f211f.svg";